import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _ from 'lodash'
import './assets/styles/index.css';

Vue.config.productionTip = false

/** Defining Loadash as Global Property. Will be accessible in template */
Object.defineProperty(Vue.prototype, '$_', { value: _ })
window.$eventBus = new Vue()

import VModal from 'vue-js-modal'
import VueCookies from 'vue-cookies'
import VueCrypt from 'vue-crypt'

Vue.use(VModal, { dialog: true })
Vue.use(VueCookies)
Vue.use(VueCrypt)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * Directive for translations.
 */
Vue.directive('trans', (el, binding) => {
  const language = store.getters.language
  let value = binding.value[binding.arg + '_' + language]
  if (value) {
    return el.innerHTML = value
  } else {
    return el.innerHTML = ''
  }
})